// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_bN-","cls2":"FilterPanel-cls2_Ur5 FilterPanel-cls1_bN-"};